const unknownError = 'Unknown Error'

const status = function (error) {
  if (!error || !error.response || !error.response.status) {
    return 0
  }

  return error.response.status
}

const message = function (error) {
  if (!error || !error.response || !error.response.data || !error.response.data.messages) {
    return unknownError
  }

  const messages = error.response.data.messages
  if (messages && messages.length >= 0) {
    return messages[0]
  } else {
    return unknownError
  }
}

export default class extends Error {
  constructor (error) {
    super(message(error))
    this.status = status(error)
    this.code = 0 // future error code support
  }
}
